(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("el-dynamic-form-design", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["el-dynamic-form-design"] = factory(require("vue"));
	else
		root["el-dynamic-form-design"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__154__) {
return 